import { connect } from 'react-redux'
import { defineMessages } from 'react-intl'
import { selectNewPrimaryResidenceBudget } from '../../../../../store/selectors/home/equity'
import { SECOND_HOME_TOPIC_KEY } from '../../../../../constants/topicKeys'
import RentBuyDetail from './RentBuyDetail'

export default {
  GemContainer: connect(state => ({
    qaTag: 'rentBuyGem',
    amount: selectNewPrimaryResidenceBudget(state),
  })),
  Detail: RentBuyDetail,
  ...defineMessages({
    question: {
      id: 'Homeowner.purchasePower.rentBuyQuestion',
      defaultMessage: 'Do I need to update my home?',
    },
    topic: {
      id: 'Homeowner.purchasePower.rentBuyTopic',
      defaultMessage: 'buying a second primary home',
    },
  }),
  topicKey: SECOND_HOME_TOPIC_KEY,
}
